import axios from "axios";

export function GetApi(path, token_Data) {
	let token = token_Data;
	if (!token || token == "") {
		try {
			token = localStorage.getItem("PPKTOKEN");
		} catch (e) {}
	}
	let headers = { Authorization: token, "Content-Type": "application/json" };
	const GetApiData = axios
		.get(path, { headers: headers })
		.then((response) => {
			return response;
		})
		.catch((err) => {
			if (err.response.data.message === "Not Authorized or invalid token.") {
				window.location.href = "/?refresh_token=true";
			}
			return err.response;
		});
	return GetApiData;
}

export function GetApiWithoutToken(path) {
	const GetApiData = axios
		.get(path)
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err.response;
		});
	return GetApiData;
}

export function PostApi(path, body) {
	let token = "";
	if (!token || token == "") {
		try {
			token = localStorage.getItem("PPKTOKEN");
		} catch (e) {}
	}
	let headers = { Authorization: token, "Content-Type": "application/json" };
	const PostApiData = axios
		.post(path, body, { headers: headers })
		.then((response) => {
			return response;
		})
		.catch((err) => {
			if (err.response.data.message === "Not Authorized or invalid token.") {
				window.location.href = "/?refresh_token=true";
			}
			return err.response;
		});
	return PostApiData;
}

export function ImageUpload(path, body) {
	let token = "";
	if (localStorage.getItem("PPKTOKEN")) {
		token = localStorage.getItem("PPKTOKEN");
	}

	let headers = { 
		Authorization: token, 
		"Content-Type": "multipart/form-data" 
	};
	
	const PostApiData = axios
		.post(path, body, { headers: headers })
		.then((response) => {
			return response;
		})
		.catch((err) => {
			if (err.response.data.message === "Not Authorized or invalid token.") {
				window.location.href = "/?refresh_token=true";
			}
			return err.response;
		});
	return PostApiData;
}


export function PostApiWithoutLogin(path, body) {
	const PostApiData = axios.post(path, body).then(res => res).catch(err => err);
	return PostApiData;
}

export function GetApiWithCustomHeaders(path, token) {
	let headers = { Authorization: token, "Content-Type": "application/json" };
	const GetApiData = axios
		.get(path, { headers: headers })
		.then((response) => {
			return response;
		})
		.catch((err) => {
			return err;
		});
	return GetApiData;
}

export function parseJwt () {
	let token = "";
	if (localStorage.getItem("PPKTOKEN")) {
		token = localStorage.getItem("PPKTOKEN");
	}
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export function FormatDate (date) {
	let normal_formate = new Date(date);
	return normal_formate.toLocaleDateString("en-US");
}
